import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from '@unite-us/ui';
import { callbacks, hooks } from '../../../config/api';
import { isHttpSuccess } from '../../utils/isHttpSuccess';
import { INSURANCE_STATUSES } from './constants';
import { CancelEnrollmentRequestMessage } from './CancelEnrollmentRequestMessage';
export var CancelEnrollmentRequestModal = function CancelEnrollmentRequestModal(_ref) {
  var _insurance$plan3;
  var insurance = _ref.insurance,
    isConfirmDialogOpen = _ref.isConfirmDialogOpen,
    onDialogStateChange = _ref.onDialogStateChange;
  var cancelEnrollmentModalRef = useRef(null);
  var _hooks$useUpdateRecor = hooks.useUpdateRecord('enrollment_request', {
      api: 'coreApi'
    }),
    updateEnrollmentRequest = _hooks$useUpdateRecor.updateRecord;
  var invalidateQueries = hooks.useInvalidateQueries();
  var onClose = function onClose() {
    cancelEnrollmentModalRef.current.closeDialog();
    onDialogStateChange(false);
  };
  useEffect(function () {
    if (isConfirmDialogOpen) {
      cancelEnrollmentModalRef.current.openDialog();
    }
  }, [isConfirmDialogOpen]);
  var onUpdate = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var result, successMessage, _insurance$plan, _insurance$plan2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return updateEnrollmentRequest(insurance.enrollment_requests[0].id, {
              enrollment_status: 'canceled'
            });
          case 3:
            result = _context.sent;
            if (isHttpSuccess(result.status)) {
              if (insurance.insurance_status === INSURANCE_STATUSES.pending_enrollment) {
                // eslint-disable-next-line max-len
                successMessage = "Pending enrollment request for ".concat((_insurance$plan = insurance.plan) === null || _insurance$plan === void 0 ? void 0 : _insurance$plan.name, " social care coverage plan canceled. Client is not enrolled.");
              } else {
                // eslint-disable-next-line max-len
                successMessage = "Pending disenrollment request for ".concat((_insurance$plan2 = insurance.plan) === null || _insurance$plan2 === void 0 ? void 0 : _insurance$plan2.name, " social care coverage plan canceled. Client is enrolled.");
              }
              callbacks.toast.success(successMessage);
              callbacks.fetchRecentUpdates();
              invalidateQueries('insurance');
            }
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            callbacks.toast.error('Failed to update request');
          case 10:
            onClose();
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function onUpdate() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(Dialog, {
    id: "cancel-enrollment-modal",
    className: "sub-dialog",
    ref: cancelEnrollmentModalRef,
    title: insurance.insurance_status === INSURANCE_STATUSES.pending_enrollment ? 'Cancel enrollment request' : 'Cancel disenrollment request',
    modal: true,
    onRequestClose: onClose,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      className: "action-item border-dark-pale-blue normal-case",
      label: "No",
      onClick: onClose
    }), /*#__PURE__*/React.createElement(Button, {
      className: "action-item border-red bg-red text-white normal-case",
      label: "Yes",
      onClick: onUpdate
    }))
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "space-y-4 mb-4"
  }, /*#__PURE__*/React.createElement(CancelEnrollmentRequestMessage, {
    insuranceStatus: insurance.insurance_status,
    planName: (_insurance$plan3 = insurance.plan) === null || _insurance$plan3 === void 0 ? void 0 : _insurance$plan3.name,
    client: insurance.person.full_name
  })))));
};
CancelEnrollmentRequestModal.propTypes = {
  insurance: PropTypes.object.isRequired,
  isConfirmDialogOpen: PropTypes.bool.isRequired,
  onDialogStateChange: PropTypes.func.isRequired
};
//# sourceMappingURL=CancelEnrollmentRequestModal.js.map